<div class="campaign-test-notification d-flex align-items-start gap-2">
  <i class="fas fa-bullhorn campaign-test-notification__icon notification-item-icon" aria-hidden="true"></i>
  <span class="small">
    {{ 'AgenticCX::Notification:Test:CampaignMessage' | abpLocalization: campaignName : sentByUserName }}
  </span>
</div>
